import { TFunction } from 'i18next';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import { AccentTradeControllerProps } from '../types';
import { getTradeTranslations } from '../../utils/getTradeTranslations';
import { NavigationBar } from '../../../common/components';
import { NavigationBackButton } from '@bts-web/core-features/navigation';
import { AcceptTradeSubscriptionWrapper } from '../AcceptTradeSubscriptionWrapper';
import { CancelTradeWithConfirmButton } from '../../Reusable/CancelTradeConfirmationModal/CancelTradeWithConfirmButton';

export const AcceptTradeController = async ({
  offerData,
  variant,
}: AccentTradeControllerProps) => {
  const { t } = await initServerTranslation();

  const translations = getTradeTranslations(t as TFunction);

  const ACCEPT_TRADE_TITLES = {
    buy: translations.buy,
    sell: translations.sell,
  };

  return (
    <>
      <NavigationBar
        title={ACCEPT_TRADE_TITLES[variant]}
        NavigationLeftSlot={<NavigationBackButton />}
        NavigationRightSlot={
          <CancelTradeWithConfirmButton translations={translations} />
        }
      />

      <AcceptTradeSubscriptionWrapper
        initialOfferData={offerData}
        offerId={offerData.id}
        translations={translations}
        variant={variant}
      />
    </>
  );
};
